import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileText, Search, BarChart2, BookOpen } from '../../components/Icons';
import styles from './Features.module.css';

function Features() {
  const { i18n } = useTranslation();
  const isID = i18n.language === 'id';

  const features = [
    {
      icon: <FileText size={22} strokeWidth={1.5} aria-hidden="true" />,
      title: isID ? 'Catat Gejala Pencernaan (GI)' : 'Track GI Symptoms',
      desc: isID
        ? 'Catat kondisi pencernaan anak setiap hari dengan form yang mudah dan terstruktur.'
        : 'Record your child\u2019s digestive condition daily with an easy, structured form.',
    },
    {
      icon: <Search size={22} strokeWidth={1.5} aria-hidden="true" />,
      title: isID ? 'Tes Skrining Berbasis Ilmiah' : 'Scientific Screening',
      desc: isID
        ? 'Skrining awal GI, tingkat keparahan gejala, dan rasa nyeri (FLACC) berbasis bukti ilmiah untuk deteksi dini.'
        : 'GSSS, FLACC, and evidence-based GI screening for early detection.',
    },
    {
      icon: <BarChart2 size={22} strokeWidth={1.5} aria-hidden="true" />,
      title: isID ? 'Visualisasi Perkembangan' : 'Progress Visualization',
      desc: isID
        ? 'Pantau perkembangan kesehatan GI anak melalui grafik yang mudah dipahami.'
        : 'Monitor your child\u2019s GI health progress through easy-to-understand charts.',
    },
    {
      icon: <BookOpen size={22} strokeWidth={1.5} aria-hidden="true" />,
      title: isID ? 'Pusat Informasi' : 'Information Hub',
      desc: isID
        ? 'Artikel dan panduan terpercaya seputar GI dan ASD untuk mendukung perawatan anak.'
        : 'Trusted articles and guides about GI and ASD to support child care.',
    },
  ];

  return (
    <section className={styles.features}>
      <div className={styles.container}>
        <div className="eyebrow">{isID ? 'Fitur Utama' : 'Key Features'}</div>
        <h2 className={`section-headline ${styles.headline}`}>
          {isID
            ? 'Semua yang Anda butuhkan dalam satu platform'
            : 'Everything you need in one platform'}
        </h2>

        <div className={styles.grid}>
          {features.map((f, i) => (
            <div key={i} className={styles.card}>
              <div className={styles.iconBox}>{f.icon}</div>
              <h3 className={styles.title}>{f.title}</h3>
              <p className={styles.desc}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;